import { c as _c } from "react/compiler-runtime";
import React, { Fragment } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
import { RadioInput } from './../RadioInput/RadioInput';
import { useCustomInput } from '../utils/useCustomInput';
export type FieldTypeRadio = {
  choices?: string[];
  required?: boolean;
  type: 'wrappedradioselect' | 'textinput' | undefined;
};
export function RadioselectGroupInput(props) {
  const $ = _c(32);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] !== props.fields) {
    t0 = props.fields.some(_temp);
    $[0] = props.fields;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hasTextInput = t0;
  let t1;
  if ($[2] !== props.fields[0].choices) {
    t1 = props.fields[0].choices?.map(_temp2);
    $[2] = props.fields[0].choices;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== props.input.onChange || $[5] !== props.input.value || $[6] !== t1) {
    t2 = {
      initInputValue: props.input.value,
      inputOnChange: props.input.onChange,
      choices: t1
    };
    $[4] = props.input.onChange;
    $[5] = props.input.value;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    handleCustomInputChange
  } = useCustomInput(t2);
  let t3;
  if ($[8] !== props.input) {
    t3 = function handleSelect(value) {
      const currentValue = props.input.value || [];
      if (currentValue.includes(value)) {
        const newValue = currentValue.filter(v => v !== value);
        props.input.onChange(newValue);
      } else {
        const newValue_0 = [...currentValue, value];
        props.input.onChange(newValue_0);
      }
    };
    $[8] = props.input;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleSelect = t3;
  const t4 = hasError ? errorId : undefined;
  const t5 = hasError ? "true" : "false";
  let t6;
  if ($[10] !== handleCustomInputChange || $[11] !== handleSelect || $[12] !== hasTextInput || $[13] !== props.fields || $[14] !== props.input.name || $[15] !== props.input.value) {
    let t7;
    if ($[17] !== handleCustomInputChange || $[18] !== handleSelect || $[19] !== hasTextInput || $[20] !== props.input.name || $[21] !== props.input.value) {
      t7 = (field_0, index) => {
        if (field_0.type === "wrappedradioselect") {
          return <Fragment key={index}>{field_0.choices?.map((choice_0, index_0) => {
              const isLast = index_0 === (field_0.choices?.length || 0) - 1;
              return <label className="block" key={index_0}><span><RadioInput label={choice_0} input={{
                    name: props.input.name,
                    onChange: event => {
                      handleSelect(event.target.value);
                    },
                    checked: props.input.value?.includes(choice_0),
                    value: choice_0
                  }} meta={{}} />{isLast && hasTextInput && <input className="input mt-4" type="text" onChange={e => handleCustomInputChange(e.target.value)} data-clarity-mask="true" />}</span></label>;
            })}</Fragment>;
        }
      };
      $[17] = handleCustomInputChange;
      $[18] = handleSelect;
      $[19] = hasTextInput;
      $[20] = props.input.name;
      $[21] = props.input.value;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    t6 = props.fields.map(t7);
    $[10] = handleCustomInputChange;
    $[11] = handleSelect;
    $[12] = hasTextInput;
    $[13] = props.fields;
    $[14] = props.input.name;
    $[15] = props.input.value;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[23] !== errorId || $[24] !== hasError || $[25] !== props.meta.error) {
    t7 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[23] = errorId;
    $[24] = hasError;
    $[25] = props.meta.error;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== t4 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t8 = <div className="relative flex flex-col gap-4" aria-describedby={t4} aria-invalid={t5}>{t6}{t7}</div>;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}
function _temp2(choice) {
  return {
    label: choice,
    value: choice
  };
}
function _temp(field) {
  return field.type === "textinput";
}